module.exports = __webpack_public_path__ + "img/appointment.a83bf32b.png";